module.exports = __webpack_public_path__ + "img/vip_title1.2c5f4278.png";